'use client';
const countItems = (navigationItems, helpCenterItems, showMore)=>{
    let items = 0;
    (navigationItems == null ? void 0 : navigationItems.length) && (items += navigationItems == null ? void 0 : navigationItems.length);
    (helpCenterItems == null ? void 0 : helpCenterItems.length) && (items += helpCenterItems == null ? void 0 : helpCenterItems.length);
    showMore && (helpCenterItems == null ? void 0 : helpCenterItems.length) && (items += 1);
    return items;
};

export { countItems };
//# sourceMappingURL=countItems.js.map
